import { Icon } from "@smartsuite/react-ui/lib";
import { Colors } from "@smartsuite/types";
import type React from "react";
import * as S from "./style";

/**
 * Fallback shown when the backend sends an input whose editor type this build
 * of the UI doesn't know how to render (e.g. a newly added editor). Rendering a
 * visible warning -- instead of silently dropping the input -- makes the gap
 * obvious during development and in the field.
 */
export const UnknownInputEditor: React.FC<{
  label?: string;
  editorKind?: string;
}> = ({ label, editorKind }) => (
  <S.StyledSection>
    <Icon
      size={"M"}
      name={"important-lined"}
      color={Colors.bRed}
      width={26}
      height={26}
    />
    <S.MessageContainer>
      <S.MessageItem>
        {label !== undefined && label !== ""
          ? `"${label}" can't be shown: this version of the app doesn't support its input type.`
          : "This input can't be shown: this version of the app doesn't support its input type."}
      </S.MessageItem>
      <S.MessageItem>
        Unknown editor type:&nbsp;
        <S.EditorType>{editorKind ?? "none"}</S.EditorType>. Try reloading or
        updating.
      </S.MessageItem>
    </S.MessageContainer>
  </S.StyledSection>
);
